import * as React from 'react';

import { Col, Form, Popover, Row, Switch } from 'antd';
import { Button, ButtonShape, Input, Space, Text } from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

import { Action, Wrapper } from 'components';
import { PlusIcon, SlackIcon, XIcon } from 'components/Icon';
import { theme } from 'styled';

const WrapIconAndGroupID = styled.div`
  display: flex;
`;

const WrapInput = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const WrapFormInputGroupID = styled.div`
  padding: 11px;
  border: 1px dashed ${props => props.theme.colors.border.main};
  width: fit-content;
  height: 290px;
  border-radius: 6px;
`;

const WrapListGroup = styled.div`
  display: flex;
  flex-direction: column;
  height: 176px;
  overflow: hidden;
  overflow-y: scroll;
`;

const GroupItem = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 12px;
  padding: 13px;
  background-color: rgba(57, 181, 74, 0.1);
  border-radius: 6px;
  justify-content: space-between;
`;

const WrapLineAddGroup = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 22px;
  font-size: ${props => props.theme.font.size.xs};
  padding: 5px 0px 10px 0px;
`;

const IconButtonStyles = css`
  background: transparent;

  border: 0px;

  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

const CButton = styled(Button)`
  color: ${p => p.theme.colors.primary.main};
  background: none;
  border: none;
  height: 22px;
  padding: 0px;
  box-shadow: none;
  text-shadow: none;

  &:hover,
  &:focus {
    background: none;
    color: ${props => props.theme.colors.text.primary};
    color: ${p => p.theme.colors.primary.main};
    box-shadow: none !important;
    text-shadow: none !important;
  }
`;

interface SlackAppProps {
  form: any;
  onSetBodyUpdate: (e: any) => void;
  listSlackGroup: any[];
  setListSlackGroup: (e: any[]) => void;
}

export const SlackApp = ({
  form,
  onSetBodyUpdate,
  listSlackGroup,
  setListSlackGroup,
}: SlackAppProps): JSX.Element => {
  React.useState<boolean>(false);
  const [group, setGroup] = React.useState<any>({});

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const addGroupID = () => {
    setIsSubmitting(true);
    const data = form.getFieldsValue(['slackURL', 'slackID']);

    if (data?.slackURL && data?.slackID) {
      listSlackGroup.push({
        id: data.slackID[0] == '#' ? data.slackID : `#${data.slackID}`,
        url: data?.slackURL,
      });

      setListSlackGroup([...listSlackGroup]);

      form.setFieldsValue({
        slackURL: '',
        slackID: '',
      });
    }
  };

  const onChange = (checked: boolean) => {
    form.setFieldsValue({ slackStatus: checked });
  };

  const deleteGroupItem = index => {
    listSlackGroup.splice(index, 1);
    setListSlackGroup([...listSlackGroup]);
  };

  const content = (
    <ul style={{ margin: '0px', padding: '5px 15px' }}>
      <li>Tìm kiếm với từ khóa incoming webhooks slack app directory</li>
      <li>Thêm ứng dụng incoming webhooks vào workspace</li>
      <li>Tạo link webhook và dán vào vị trí này</li>
    </ul>
  );

  return (
    <Form form={form} onValuesChange={onSetBodyUpdate}>
      <Wrapper style={{ padding: '0px' }}>
        <Row>
          <Col
            lg={6}
            sm={6}
            style={{ display: 'flex', alignItems: 'center' }}
            xs={24}
          >
            <Text>Hiển thị thông báo:</Text>
          </Col>
          <Col lg={18}>
            <Form.Item name="slackStatus" style={{ marginBottom: '0px' }}>
              <Switch defaultChecked onChange={onChange} />
            </Form.Item>
          </Col>
        </Row>
        <Space height={30} />
        <Row>
          <Col lg={6} style={{ display: 'flex' }}>
            <Text>Danh sách kênh trò chuyện:</Text>
          </Col>

          <Col lg={18}>
            <WrapFormInputGroupID>
              <WrapInput>
                <Popover content={content} placement="bottom">
                  <div>
                    <Form.Item name="slackURL" style={{ marginBottom: '0px' }}>
                      <Input
                        height={theme.input.height.md}
                        placeholder="Nhập đường dẫn Webhook"
                        styles={{ borderRadius: '6px 0px 0px 6px' }}
                        width="500px"
                      />
                    </Form.Item>
                  </div>
                </Popover>
                <Form.Item name="slackID" style={{ marginBottom: '0px' }}>
                  <Input
                    height={theme.input.height.md}
                    placeholder="Nhập tên nhóm"
                    styles={{
                      borderRadius: '0px 6px 6px 0px',
                      borderLeft: 'none',
                    }}
                    value={group.id}
                    width="169px"
                  />
                </Form.Item>
              </WrapInput>

              <WrapLineAddGroup>
                <Text>Kênh nhận thông báo</Text>
                <CButton onClick={addGroupID}>
                  {' '}
                  <PlusIcon height={8} width={8} /> <Space width={3} /> Thêm mới
                </CButton>
              </WrapLineAddGroup>
              <WrapListGroup>
                {listSlackGroup.length > 0 &&
                  listSlackGroup?.map((item, index) => (
                    <GroupItem>
                      <WrapIconAndGroupID>
                        <SlackIcon width={24} />

                        <Text
                          styles={{ marginLeft: '15px', maxWidth: '550px' }}
                        >
                          {item.url}/{item.id}
                        </Text>
                      </WrapIconAndGroupID>
                      <Action
                        buttonProps={{
                          shape: ButtonShape.Circle,
                          icon: {
                            children: <XIcon color="#F05540" width={18} />,
                          },
                          // width: '18px',
                          // height: '18px',
                          styles: IconButtonStyles,
                        }}
                        onClick={() => deleteGroupItem(index)}
                      />
                    </GroupItem>
                  ))}
              </WrapListGroup>
            </WrapFormInputGroupID>
          </Col>
        </Row>
      </Wrapper>
    </Form>
  );
};
